'use client'
import Image from 'next/image'
import { useContextElement } from '@/context/Context'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import { Navigation } from 'swiper/modules'
import { useEffect, useState } from 'react'
import { allProducts } from '@/data/products'
import Styles from '@/components/otherPages/AccountWishlist.module.css'

const formatNumber = (num) => {
  return num.toLocaleString('en-US')
}

export default function AccountWishlist() {
  const { wishList, toggleWishlist } = useContextElement()
  const [wishlistProducts, setWishlistProducts] = useState(wishList)

  useEffect(() => {
    setWishlistProducts(wishList)
  }, [wishList])

  const judgeIsAddWishList = (id) => {
    const isAdded = wishList.some((item) => item.ProductID === id)
    return isAdded ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z" />
      </svg>
    )
  }

  return (
    <div className="col-lg-9">
      <div className="page-content my-account__wishlist" style={{ padding: 0 }}>
        {wishlistProducts.length ? (
          <div className={Styles.grid} id="products-grid">
            {wishlistProducts.map((elm, i) => (
              <div className={Styles.cardBox} key={i}>
                <div className="product-card mb-3 mb-md-4 mb-xxl-5">
                  <div className="pc__img-wrapper">
                    <Swiper
                      resizeObserver
                      modules={[Navigation]}
                      slidesPerView={1}
                      navigation={{ prevEl: '.prev' + i, nextEl: '.next' + i }}
                      observer
                      observeParents
                      className="swiper-container background-img js-swiper-slider"
                    >
                      {elm.PictureData.map((p, j) => (
                        <SwiperSlide key={j}>
                          <Link href={`/product-list/${elm.ProductID}`}>
                            <Image
                              loading="lazy"
                              src={p.Name}
                              width={330}
                              height={400}
                              alt={elm.ProductName}
                              className="pc__img"
                              style={{ objectFit: 'contain' }}
                            />
                          </Link>
                        </SwiperSlide>
                      ))}

                      <span
                        className={`cursor-pointer pc__img-prev ${'prev' + i}`}
                      >
                        <svg width="7" height="11" viewBox="0 0 7 11">
                          <use href="#icon_prev_sm" />
                        </svg>
                      </span>
                      <span
                        className={`cursor-pointer pc__img-next ${'next' + i}`}
                      >
                        <svg width="7" height="11" viewBox="0 0 7 11">
                          <use href="#icon_next_sm" />
                        </svg>
                      </span>
                    </Swiper>

                    <button
                      className="btn-remove-from-wishlist"
                      style={{ left: 0 }}
                      onClick={() => toggleWishlist(elm)}
                    >
                      <svg width="12" height="12" viewBox="0 0 12 12">
                        <use href="#icon_close" />
                      </svg>
                    </button>
                  </div>

                  <div className="pc__info position-relative px-2">
                    <div className="d-flex">
                      <h6
                        className="pc__title"
                        style={{ paddingRight: '20px' }}
                      >
                        {elm.ProductName}
                      </h6>
                      <button
                        className="pc__btn-wl position-absolute end-0 bg-transparent border-0 js-add-wishlist active"
                        title="Remove From Wishlist"
                        onClick={() => toggleWishlist(elm)}
                      >
                        {judgeIsAddWishList(elm.ProductID)}
                      </button>
                    </div>

                    <div className="product-card__price d-flex">
                      {elm.SuggestPrice > elm.Price ? (
                        <>
                          <span className="money price price-old">
                            ${formatNumber(elm.SuggestPrice)}
                          </span>
                          <span className="money price-sale current-price">
                            ${elm.Price}
                          </span>
                        </>
                      ) : (
                        <span className="money current-price">
                          ${elm.SuggestPrice}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="fs-18">還沒有加入商品</div>
        )}
      </div>
    </div>
  )
}
